import { isInWix } from './is-in-wix';
import { scrollToAppTop } from './scroll-to';
import { isInEditor } from './view-mode';

export default function scrollOnHistoryChange(store, history) {
  const shouldUseSdkScroll = isInWix();

  let lastLocation = {};
  history.listen(location => {
    if (isInEditor()) {
      return;
    }

    if (lastLocation.pathname && lastLocation.pathname !== location.pathname) {
      shouldUseSdkScroll && scrollToAppTop();
    }
    lastLocation = location;
  });
}
